import { useState } from "react";
import { DatePicker, Dropdown } from "antd";
import dayjs from "dayjs";
import { DownOutlined } from "@ant-design/icons";

const { RangePicker } = DatePicker;

export default function CustomDateRange({ value, onChange }) {
  const defaultDates = [dayjs(), dayjs().add(7, "day")]; // today → +7 days
  const [open, setOpen] = useState(false);
  const [dates, setDates] = useState(value || defaultDates);

  const handleApply = (val) => {
    setDates(val);
    onChange?.(val);
    setOpen(false);
  };

  const renderDateCard = (date, label) => {
    if (!date) {
      return (
        <div className="cursor-pointer border border-gray-300 rounded-md px-4 py-3 w-48 flex justify-between">
          <span className="">{label}</span>
          <DownOutlined className="" />
        </div>
      );
    }

    return (
      <div className="cursor-pointer rounded-md w-48">
        <div className="text-sm flex items-center mb-4">
          {label} <DownOutlined className="ml-1" />
        </div>
        <div className="flex items-baseline gap-1">
          <span className="text-2xl font-bold">{dayjs(date).format("DD")}</span>
          <span className="text-lg font-medium">
            {dayjs(date).format("MMM'YY")}
          </span>
        </div>
        <div className="text-sm">{dayjs(date).format("dddd")}</div>
      </div>
    );
  };

  const picker = (
    <div className="bg-white p-4 shadow-lg rounded-md">
      <RangePicker
        open
        value={dates}
        onChange={handleApply}
        className="w-full"
        style={{ border: "none" }}
      />
    </div>
  );

  return (
    <Dropdown
      dropdownRender={() => picker}
      open={open}
      onOpenChange={setOpen}
      trigger={["click"]}
    >
      <div className="flex gap-2">
        {renderDateCard(dates?.[0], "Check-In")}
        {renderDateCard(dates?.[1], "Check-Out")}
      </div>
    </Dropdown>
  );
}
